module.exports = __webpack_public_path__ + "static/media/paidy-app-qr-code-universal.ec7885f3.png";